
/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @since v0.1.0
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @example
 *
 *      not(true); //=> false
 *      not(false); //=> true
 *      not(0); //=> true
 *      not(1); //=> false
 */
const not =<T>(a:T):boolean=> !a;
export default not;




// WEBPACK FOOTER //
// ./src/not.ts